import type { Hero } from '../types';

/** ドラフトで想定する5レーン（データの `lanes` と一致させる） */
export const STANDARD_DRAFT_LANES = [
  'Roam',
  'Mid Lane',
  'Gold Lane',
  'Exp Lane',
  'Jungle',
] as const;

/**
 * 各ヒーローを互いに異なる標準レーンに1対1で割り当て可能か（二部マッチング）
 */
export function canAssignTeamToDistinctLanes(heroes: Hero[]): boolean {
  const n = heroes.length;
  if (n === 0) {
    return true;
  }
  if (n > STANDARD_DRAFT_LANES.length) {
    return false;
  }

  const laneCount = STANDARD_DRAFT_LANES.length;
  const adj: number[][] = heroes.map(h => {
    const e: number[] = [];
    for (let i = 0; i < laneCount; i++) {
      if (h.lanes.includes(STANDARD_DRAFT_LANES[i])) {
        e.push(i);
      }
    }
    return e;
  });

  if (adj.some(edges => edges.length === 0)) {
    return false;
  }

  const matchLane = new Array<number>(laneCount).fill(-1);

  function tryAugment(hIdx: number, seenLane: boolean[]): boolean {
    for (const laneIdx of adj[hIdx]) {
      if (seenLane[laneIdx]) {
        continue;
      }
      seenLane[laneIdx] = true;
      const prev = matchLane[laneIdx];
      if (prev === -1 || tryAugment(prev, seenLane)) {
        matchLane[laneIdx] = hIdx;
        return true;
      }
    }
    return false;
  }

  for (let h = 0; h < n; h++) {
    const seenLane = new Array<boolean>(laneCount).fill(false);
    if (!tryAugment(h, seenLane)) {
      return false;
    }
  }
  return true;
}
